import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PhotovoltaiquePage from './pages/PhotovoltaiquePage';
import PompesChaleurPage from './pages/PompesChaleurPage';
import IsolationPage from './pages/IsolationPage';
import RenovationGlobalePage from './pages/RenovationGlobalePage';
import RealisationsPage from './pages/RealisationsPage';
import ToutComprendrePage from './pages/ToutComprendrePage';
import './App.css';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          const headerHeight = 80;
          const top = el.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/solutions/photovoltaique" element={<PhotovoltaiquePage />} />
        <Route path="/solutions/pompes-chaleur" element={<PompesChaleurPage />} />
        <Route path="/solutions/isolation" element={<IsolationPage />} />
        <Route path="/solutions/renovation-globale" element={<RenovationGlobalePage />} />
        <Route path="/realisations" element={<RealisationsPage />} />
        <Route path="/tout-comprendre" element={<ToutComprendrePage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
